"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QR_SKELETON = exports.MARKET_EXCEPTIONS = void 0;
const MARKET_EXCEPTIONS = exports.MARKET_EXCEPTIONS = 'market-exceptions';
const QR_SKELETON = exports.QR_SKELETON = 'qr-skeleton';